import { useEffect, useState } from "react"

declare global {
  interface Window {
    mapboxgl?: any
  }
}

export function useMapboxLoader() {
  const [ready, setReady] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (window.mapboxgl) {
      setReady(true)
      return
    }

    const existingScript = document.querySelector<HTMLScriptElement>('script[data-mapbox-gl]')
    const existingCss = document.querySelector<HTMLLinkElement>('link[data-mapbox-gl-css]')

    if (!existingCss) {
      const link = document.createElement("link")
      link.rel = "stylesheet"
      link.href = "https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.css"
      link.dataset.mapboxGlCss = "true"
      document.head.appendChild(link)
    }

    const onLoad = () => setReady(true)
    const onError = () => setError("Failed to load Mapbox")

    if (existingScript) {
      existingScript.addEventListener("load", onLoad, { once: true })
      existingScript.addEventListener("error", onError, { once: true })
      return () => {
        existingScript.removeEventListener("load", onLoad)
        existingScript.removeEventListener("error", onError)
      }
    }

    const script = document.createElement("script")
    script.src = "https://api.mapbox.com/mapbox-gl-js/v3.1.2/mapbox-gl.js"
    script.async = true
    script.dataset.mapboxGl = "true"
    script.onload = onLoad
    script.onerror = onError
    document.head.appendChild(script)

    return () => {
      script.onload = null
      script.onerror = null
    }
  }, [])

  return { ready, error }
}
